import { render, staticRenderFns } from "./UserDiskSpace.vue?vue&type=template&id=6b54e379&"
import script from "./UserDiskSpace.vue?vue&type=script&lang=ts&"
export * from "./UserDiskSpace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports